document.addEventListener("click", (e) => {
  const isTouch = window.matchMedia("(hover: none), (pointer: coarse)").matches;
  if (!isTouch) return;

  const cardWrapper = e.target.closest(".card-wrapper");
  if (!cardWrapper) return;

  const media = cardWrapper.querySelector(".media.media--hover-effect");
  if (!media) return;

  const imgs = media.querySelectorAll("img");
  if (imgs.length < 2) return;

  const link = e.target.closest("a");
  if (link) {
    if (!cardWrapper.classList.contains("card--tap-hover")) {
      e.preventDefault();
      cardWrapper.classList.add("card--tap-hover");
      setTimeout(() => cardWrapper.classList.remove("card--tap-hover"), 2000);
    }
    return;
  }

  cardWrapper.classList.toggle("card--tap-hover");
});
